module.exports = __webpack_public_path__ + "static/DC-09157f16f704f59a0d68acbbe591a5f2.png";